/* eslint-disable no-unused-vars */
import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

//  TODO: Ensure only the user with the uid can set this - should be easy in
const setVoteForFeature = (uid, voteType, itemKey, featureType) => {
	if (uid) {
		const key = [uid, itemKey, featureType].join('-')
		return firestore.collection('featureVotes').doc(key)
			.set({ uid, voteType, itemKey, featureType })
			.catch(exception => Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, uid, exception)))
	}
	return Promise.reject(errorOfType(errorTypes.KEYNOTSPECIFIED, 'No User ID specified'))
}

export default setVoteForFeature



// WEBPACK FOOTER //
// ./src/dataservices/setVoteForFeature.js